(function () {
    function initHomeHeroVideo() {
        var video = document.querySelector('.home-template #dewa-home-hero-video');

        if (!video) {
            return;
        }

        var resumeAfterVisibility = false;

        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;

        function keepMuted() {
            if (!video.muted || video.volume !== 0) {
                video.muted = true;
                video.volume = 0;
            }
        }

        function playVideo() {
            keepMuted();
            var playPromise = video.play();

            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {
                    document.documentElement.classList.add('dewa-home-hero-autoplay-blocked');
                });
            }
        }

        video.addEventListener('play', function () {
            keepMuted();
            document.documentElement.classList.remove('dewa-home-hero-autoplay-blocked');
        });
        video.addEventListener('volumechange', keepMuted);
        video.addEventListener('error', function () {
            document.documentElement.classList.add('dewa-home-hero-media-error');
        });

        document.addEventListener('visibilitychange', function () {
            if (document.hidden && !video.paused) {
                resumeAfterVisibility = true;
                video.pause();
            } else if (!document.hidden && resumeAfterVisibility) {
                resumeAfterVisibility = false;
                playVideo();
            }
        });

        if (!document.hidden) {
            playVideo();
        } else {
            resumeAfterVisibility = true;
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHomeHeroVideo, {once: true});
    } else {
        initHomeHeroVideo();
    }
}());
